module.exports = __webpack_public_path__ + "img/code.0d21f1ae.png";